import React, { useState } from "react";
import { 
  auth, 
  signInWithEmailAndPassword, 
  createUserWithEmailAndPassword,
  updateProfile  } from "./firebase";
import { 
  Container, 
  Box, 
  TextField, 
  Button, 
  Typography, 
  Paper,
  Link 
} from "@mui/material";

const Login = () => {
  const [isSignUp, setIsSignUp] = useState(false); // Toggle between login and signup
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [error, setError] = useState("");
  //const navigate = useNavigate();
  const [success, setSuccess] = useState("");


  const handleAuth = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    try {
      let userCredential;

      if (isSignUp) {
        userCredential = await createUserWithEmailAndPassword(auth, email, password);
        
        // Set display name from first + last name
        await updateProfile(userCredential.user, {
          displayName: `${firstName} ${lastName}`,
        });

        console.log("User signed up:", userCredential.user);
        setSuccess("✅ Account created successfully!");
      } else {
        userCredential = await signInWithEmailAndPassword(auth, email, password);
        console.log("User logged in:", userCredential.user);
        setSuccess("✅ Logged in successfully!");
      }
    } catch (err) {
      console.error("Auth error:", err.message);
      setError(err.message);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        component={Paper}
        elevation={10}
        sx={{
          mt: 10,
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          borderRadius: "15px",
          background: "rgba(26, 26, 46, 0.9)", // Glassmorphism effect
          backdropFilter: "blur(10px)",
        }}
      >
        <Typography variant="h4" gutterBottom sx={{ color: "#00eaff" }}>
          {isSignUp ? "Sign Up" : "Login"}
        </Typography>

        {error && (
          <Typography color="error" variant="body2" sx={{ mb: 2 }}>
            {error}
          </Typography>
        )}

        {success && (
          <Typography
            sx={{
              mb: 2,
              color: "#4caf50", // green
              backgroundColor: "#e8f5e9",
              px: 2,
              py: 1,
              borderRadius: "5px",
              fontWeight: 500,
              width: "100%",
              textAlign: "center",
            }}
          >
            {success}
          </Typography>
        )}

        <form onSubmit={handleAuth} style={{ width: "100%" }}>
          {isSignUp && (
            <>
              <TextField
                label="First Name"
                variant="outlined"
                fullWidth
                required
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                sx={{ mb: 2, input: { color: "#e0e0e0" } }}
              />
              <TextField
                label="Last Name"
                variant="outlined"
                fullWidth
                required
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                sx={{ mb: 2, input: { color: "#e0e0e0" } }}
              />
            </>
          )}
          <TextField
            label="Email"
            type="email"
            variant="outlined"
            fullWidth
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={{ mb: 2, input: { color: "#e0e0e0" } }}
          />

          <TextField
            label="Password"
            type="password"
            variant="outlined"
            fullWidth
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            sx={{ mb: 2, input: { color: "#e0e0e0" } }}
          />

          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{
              mt: 2,
              py: 1.5,
              backgroundColor: "#00eaff",
              color: "#0d1b2a",
              fontSize: "1rem",
              fontWeight: "bold",
              "&:hover": { backgroundColor: "#00c2d1" },
            }}
          >
            {isSignUp ? "Create Account" : "Login"}
          </Button>
        </form>
        <Typography variant="body2" sx={{ mt: 2, color: "#aaa" }}>
          {isSignUp ? "Already have an account?" : "Don't have an account?"}{" "}
          <Link
            component="button"
            onClick={() => setIsSignUp(!isSignUp)}
            sx={{ color: "#00eaff", textDecoration: "underline" }}
          >
            {isSignUp ? "Login" : "Sign Up"}
          </Link>
        </Typography>
      </Box>
    </Container>
  );
};

export default Login;
